import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Countries from "../pages/countries/page";
import Contact from "../pages/contact/page";
import Gallery from "../pages/gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkimizda",
    element: <About />,
  },
  {
    path: "/hizmetler",
    element: <Services />,
  },
  {
    path: "/hedef-ulkeler",
    element: <Countries />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "/galeri",
    element: <Gallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
